(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
    // const open_cart_drawer = document.querySelector(".open-cart-drawer");
    // const close_cart_drawer = document.querySelector(".close-cart-drawer");

    // document.addEventListener('DOMContentLoaded', ()=>{
    //     document.querySelector(".open-cart-drawer").addEventListener('click', openCart)


    //     document.querySelector(".close-cart-drawer").addEventListener('click', closeCart)

    //     document.querySelector(".cart-drawer-container").addEventListener('click', (e) => {
    //         if (e.target === e.currentTarget) {
    //             openCart()
    //         }
    //     });
    // })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
const cartPageQuantityInput = document.querySelectorAll('.cart-page-quantity-input');
const cartPageDecrementBtn = document.querySelectorAll('.cart-decrement-page-btn');
const cartPageIncrementBtn = document.querySelectorAll('.cart-increment-page-btn');

cartPageDecrementBtn.forEach((btn, index) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (cartPageQuantityInput[index].value > 1) {
            cartPageQuantityInput[index].value = parseInt(cartPageQuantityInput[index].value) - 1;
            btn.closest('form').submit();
        } 
    })
})
cartPageIncrementBtn.forEach((btn, index) => {
    btn.addEventListener('click', (e) => {
             e.preventDefault();
            cartPageQuantityInput[index].value = parseInt(cartPageQuantityInput[index].value) + 1;
            btn.closest('form').submit();
    })
})
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {

        let featuredQuantity = 1
        const featuredProductAddToCartBtn = document.querySelector('.featured-product-add-to-cart')
        const featuredProductError = document.querySelector('.featured-product-error')
        const featuredProduct = document.querySelector('.featured-product');
        const featuredProductData = JSON.parse(featuredProduct.dataset.featuredProduct);
        // console.log(featuredProductData);


        function changeFeaturedProductQuantity(change) {
            featuredQuantity = Math.max(1, featuredQuantity + change);
            document.querySelector("#featured-product-quantity").value = featuredQuantity;
            // console.log(featuredQuantity)
        }

        // Funtion to update featuredPrice
        function updateFeaturedProductPrice(newPriceInCents) {
            const priceElement = document.querySelector(".featured-product-price");
            if (!priceElement) return;

            // console.log(newPriceInCents);
            priceElement.textContent = newPriceInCents;
        }

        // Funtion to check variant availability

        function checkFeaturedProductVariantAvailability(matchedVariantAvailable) {
            if (!featuredProductAddToCartBtn) return; // Safety check

            featuredProductAddToCartBtn.disabled = !matchedVariantAvailable;
            
            if (matchedVariantAvailable) {
                featuredProductAddToCartBtn.classList.add('available');
                featuredProductAddToCartBtn.classList.remove('not-available');
                featuredProductAddToCartBtn.querySelector('p').textContent = "Add To Cart";
            } else {
                featuredProductAddToCartBtn.classList.remove('available');
                featuredProductAddToCartBtn.classList.add('not-available');
                featuredProductAddToCartBtn.querySelector('p').textContent = "Out of stock";
            }
        }

          document
            .querySelector(".featured-product-quantity-selector-minus")
            .addEventListener("click", () => changeFeaturedProductQuantity(-1));
        document
            .querySelector(".featured-product-quantity-selector-add")
            .addEventListener("click", () => changeFeaturedProductQuantity(1));


            // Funtion to get matchedVariant
        function getFeaturedProductMatchedVariant() {
            const selectedOptions = Array.from(
                document.querySelectorAll(".featured-product-size-dropdown")
            ).map((select) => select.value);

            const matchedVariant = featuredProductData.variants.find((variant) => {
                return selectedOptions.every((optionValue, index) => {
                return variant.options[index] === optionValue;
                });
            });

            return matchedVariant;
        }

          // Funtion on variantChange
        function onFeaturedProductVariantChange(event) {
        //   console.log(event.target.id)
            // Find parent container
            const featuredProductBottom = event.target.closest(".featured-product-bottom");
            const sectionId = featuredProductBottom.dataset.featuredProductSectionId;

            featuredProductError.style.display = "none";

            // loading for button to indicate loading

            featuredProductAddToCartBtn.disabled  = true;
            featuredProductAddToCartBtn.classList.add('loading')

            // Get selected option values from ALL dropdowns
            const selectedOptionValues = Array.from(
            featuredProductBottom.querySelectorAll("select")
            )
            .map((selectEl) => {
                const selectedOption = selectEl.options[selectEl.selectedIndex];
                return selectedOption.value;
            })
            .filter(Boolean);

            // check the featured data variant for the option value selected 

            // 1. Find the single matching variant object first
            const matchedVariant = featuredProductData.variants.find((variant) => {
                const variantOptions = variant.options;
                
                // Ensure lengths match first to avoid index errors
                if (!Array.isArray(variantOptions) || variantOptions.length !== selectedOptionValues.length) {
                    return false;
                }

                // Check if every option value matches
                return variantOptions.every((option, index) => {
                    return option === selectedOptionValues[index];
                });
            });

            // 2. Run logic based on whether a match was found
            if (matchedVariant) {
                // Variant exists, update price
                if (typeof updateFeaturedProductPrice === 'function') {
                    updateFeaturedProductPrice(Shopify.formatMoney(matchedVariant.price));
                }
                
                // Variant exists, check if it is in stock (available: true) or out of stock (available: false)
                checkFeaturedProductVariantAvailability(matchedVariant.available);

            } else {
                console.log('No variant found for this combination.');
                checkFeaturedProductVariantAvailability(false);
            }
            featuredProductAddToCartBtn.classList.remove('loading')
        }

        // Use event delegation on a static parent element
        const featuredProductBottomContainer = document.querySelector(".featured-product-bottom");
        if (featuredProductBottomContainer) {
            featuredProductBottomContainer.addEventListener("change", (event) => {
              if (event.target.matches(".featured-product-size-dropdown")) {
                  onFeaturedProductVariantChange(event);
              }
            });
        }

        // add to cart function

        // Funtion to add to cart
        async function featuredAddToCart(e) {
            e.preventDefault();
            // console.log("add to cart button clicked");

            const matchedVariant = getFeaturedProductMatchedVariant();

            const formData = {
                items: [
                    {
                        id: matchedVariant.id,
                        quantity: featuredQuantity,
                    },
                ],
                sections: "cart-drawer,header",
            };

            // console.log(formData);

            try {
            featuredProductAddToCartBtn.disabled  = true;
            featuredProductAddToCartBtn.style.cursor = "progress";
            featuredProductAddToCartBtn.querySelector('p').textContent = "Loading...";
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) {
              if(response.status === 422){
                featuredProductError.style.display = "block";
                featuredProductError.textContent = data.description;
                updateCartDrawer();
                openCart();
                return
              }
                throw new Error(data);
            }
            // console.log(data);
            const cart = await getCart();
            updateCartDrawer();
            updateCartCount(data.sections.header);
            // console.log(cart);
            openCart();
            } catch (error) {
              console.log(error);
              featuredProductAddToCartBtn.querySelector('p').textContent = "Out of Stock";
              featuredProductAddToCartBtn.style.cursor = "";
            } finally {
              featuredProductAddToCartBtn.querySelector('p').textContent = "Add to Cart";
              featuredProductAddToCartBtn.disabled  = false;
              featuredProductAddToCartBtn.style.cursor = "";
            }

            // setTimeout(() => {
            //     featuredProductError.style.display = "none";
            // }, 2000);
        }

        featuredProductAddToCartBtn.addEventListener("click", featuredAddToCart);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menu_button = document.querySelector('.header_hamburger_menu');
  const menu = document.querySelector('.header__mobile_menu');

  menu_button.addEventListener('click', () => {
    const isOpen = menu_button.getAttribute('aria-expanded') === 'true';
    const nextState = !isOpen;
    menu_button.setAttribute('aria-expanded', String(nextState));
    menu.classList.toggle('active');
    if (nextState) {
      const firstFocusable = menu.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    } else {
      menu_button.focus();
    }
  });

  menu.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      menu_button.setAttribute('aria-expanded', 'false');
      menu.classList.toggle('active');
      menu_button.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const showPasswordBtn = document.querySelector('#show_password_section');
  const showNewsletterBtn = document.querySelector('#show_password_newsletter_section');

  showPasswordBtn.addEventListener('click', () => {
    document.querySelector('#password_container').classList.remove('hidden');
    document.querySelector('#password_newsletter_container').classList.add('hidden');
    showPasswordBtn.setAttribute('aria-expanded', 'true');
    showNewsletterBtn.setAttribute('aria-expanded', 'false');
  });

  showNewsletterBtn.addEventListener('click', () => {
    document.querySelector('#password_container').classList.add('hidden');
    document.querySelector('#password_newsletter_container').classList.remove('hidden');
    showNewsletterBtn.setAttribute('aria-expanded', 'true');
    showPasswordBtn.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
